/**
 * useSelectionChip — the current chip-eligible Word selection's text.
 *
 * Thin React adapter over ``wordProbe.subscribeSelectionChip``: the probe
 * is the one ambient selection read the add-in keeps (cheap, bounded,
 * short-circuits on Ctrl+A). Returns the selected text while the
 * selection is chip-eligible, null otherwise.
 *
 * ``enabled`` gates the subscription itself — while false no
 * DocumentSelectionChanged handler is attached and the hook returns null.
 */

import { useEffect, useState } from "react";
import { subscribeSelectionChip } from "../../services/wordProbe";

export function useSelectionChip(enabled: boolean): string | null {
  const [text, setText] = useState<string | null>(null);
  useEffect(() => {
    if (!enabled) {
      setText(null);
      return;
    }
    return subscribeSelectionChip((state) => setText(state.visible && state.text ? state.text : null));
  }, [enabled]);
  return text;
}
